<div *ngIf="callRecorderEnabled || screenRecorderEnabled" class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li *ngIf="callRecorderEnabled && canManageSettings" [ngbNavItem]="1">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::CallRecorder' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-call-recorder-settings></ca-call-recorder-settings>
      </ng-template>
    </li>
    <li *ngIf="screenRecorderEnabled && canManageSettings" [ngbNavItem]="2">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::ScreenRecorder' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-screen-recorder-settings></ca-screen-recorder-settings>
      </ng-template>
    </li>
    <li *ngIf="canAccessManagement" [ngbNavItem]="3">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::RecorderManagement:Management' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-setting-definitions
          [information]="'Settings::SettingsManagementInfo'"
          [items]="settingsDefinitionItems"></ca-setting-definitions>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
